<template>
  <header class="hero" id="top">
    <div class="wrap">
      <p class="eyebrow">贵州微米数字信息科技有限公司<span class="dot"> · </span>AI 落地服务商</p>
      <h1>把 AI 用进你的业务流程</h1>
      <p class="hero-sub">我们不卖概念。你说清要解决什么问题, 我们交付<strong>能跑起来的系统</strong>, 并确保你的团队用得起来。</p>
      <div class="cta-row">
        <a class="btn btn-primary" href="#contact">加微信, 先聊起来</a>
        <a class="btn btn-ghost" href="#services">看看我们能做什么</a>
      </div>
      <div class="hero-trust">
        <span>十年软件交付功底</span>
        <span>贵阳团队, 服务全国</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style scoped>
.hero {
  padding: 128px 0 104px;
  text-align: center;
}

.eyebrow {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 1.5px;
  color: var(--ink-3);
  margin-bottom: 26px;
}

.eyebrow .dot {
  color: var(--accent);
}

.hero h1 {
  font-size: 54px;
  font-weight: 600;
  line-height: 1.16;
  letter-spacing: -0.5px;
  max-width: 720px;
  margin: 0 auto 26px;
}

.hero-sub {
  font-size: 17px;
  color: var(--ink-2);
  max-width: 820px;
  margin: 0 auto 40px;
}

.hero-sub strong {
  color: var(--ink);
  font-weight: 500;
}

.cta-row {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-bottom: 56px;
}

.hero-trust {
  font-family: var(--mono);
  font-size: 12.5px;
  color: var(--ink-3);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px 22px;
}

@media (max-width: 860px) {
  .hero {
    padding: 84px 0 72px;
  }

  .hero h1 {
    font-size: 38px;
  }

  .hero-sub {
    font-size: 15.5px;
  }

  .cta-row {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
